'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    padding: 0 20px;\n  '], ['\n    padding: 0 20px;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: block;\n    white-space: nowrap;\n  '], ['\n    display: block;\n    white-space: nowrap;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    font-size: 24px;\n  '], ['\n    font-size: 24px;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _H = require('UIComponents/elements/headings/H7');

var _H2 = _interopRequireDefault(_H);

var _colors = require('HubStyleTokens/colors');

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _responsiveBreakpoints = require('pricing-pages-unified-ui/utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _CodeSplitEnvWrapper = require('pricing-pages-unified-ui/components/CodeSplitEnvWrapper');

var _CodeSplitEnvWrapper2 = _interopRequireDefault(_CodeSplitEnvWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PhoneSupportWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'PhoneSupport__PhoneSupportWrapper'
})(['', ''], _responsiveBreakpoints2.default.tablet(_templateObject));

var PhoneSupportContainer = _styledComponents2.default.div.withConfig({
  displayName: 'PhoneSupport__PhoneSupportContainer'
})(['border:', ';border-radius:200px;margin:0 auto;text-align:center;padding:15px 44px 0;'], function (_ref) {
  var border = _ref.border;
  return border ? '1px ' + _colors.BATTLESHIP + ' solid' : 'none';
});

var PhoneNumberContainer = _styledComponents2.default.div.withConfig({
  displayName: 'PhoneSupport__PhoneNumberContainer'
})(['display:inline-flex;align-items:flex-start;', ''], _responsiveBreakpoints2.default.tablet(_templateObject2));

var StyledIcon = (0, _styledComponents2.default)(_UIIcon2.default).withConfig({
  displayName: 'PhoneSupport__StyledIcon'
})(['margin-right:10px;font-size:15px;', ''], _responsiveBreakpoints2.default.tablet(_templateObject3));

var StyledHeader = (0, _styledComponents2.default)(_H2.default).withConfig({
  displayName: 'PhoneSupport__StyledHeader'
})(['line-height:1.8;margin-bottom:0.75em;text-align:center;font-size:1.15em;.phone-support-header{display:block;}']);

function PhoneSupport(_ref2) {
  var phoneSourceId = _ref2.phoneSourceId,
      border = _ref2.border,
      showCopy = _ref2.showCopy,
      screen = _ref2.screen;

  return _react2.default.createElement(
    PhoneSupportWrapper,
    null,
    showCopy && _react2.default.createElement(
      StyledHeader,
      null,
      _react2.default.createElement(_FormattedMessage2.default, {
        message: 'pricingPage.pages.crm.notSure',
        className: 'phone-support-header'
      }),
      _react2.default.createElement(_FormattedMessage2.default, {
        message: 'pricingPage.pages.crm.notSureSubHeader',
        className: 'phone-support-subheader'
      })
    ),
    _react2.default.createElement(
      PhoneSupportContainer,
      {
        className: 'phone-support-container',
        border: border
      },
      _react2.default.createElement(
        PhoneNumberContainer,
        null,
        _react2.default.createElement(StyledIcon, { name: 'phone' }),
        _react2.default.createElement(_CodeSplitEnvWrapper2.default, {
          authedComponentLoader: function authedComponentLoader() {
            return import( /* webpackChunkName: "authed-chunk" */'pricing-pages-unified-ui/components/common/phone-numbers/AuthedPhoneNumber');
          },
          publicComponentLoader: function publicComponentLoader() {
            return import( /* webpackChunkName: "public-chunk" */'pricing-pages-unified-ui/components/common/phone-numbers/PublicPhoneNumber');
          },
          authedComponentProps: { phoneSourceId: phoneSourceId, screen: screen },
          publicComponentProps: { phoneSourceId: phoneSourceId, screen: screen }
        })
      )
    )
  );
}

PhoneSupport.propTypes = {
  phoneSourceId: _react.PropTypes.string.isRequired,
  border: _react.PropTypes.bool.isRequired,
  showCopy: _react.PropTypes.bool.isRequired,
  screen: _react.PropTypes.string.isRequired
};

PhoneSupport.defaultProps = {
  border: true,
  showCopy: true
};

exports.default = PhoneSupport;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/PhoneSupport.js
// module id = 146
// module chunks = 3 4